import React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

type TMenuItem = {
  title: string;
  path: string;
  key?: string;
};
interface Props extends RouteComponentProps {
  menuItems: Array<TMenuItem>;
  filter?: React.ReactElement;
}

const MenuItemActive = styled.div<{ active: boolean }>`
  width: 8px;
  height: 64px;
  flex-grow: 0;
  background-color: ${(props) => (props.active ? '#FF5A0F' : 'transparent')};
`;

const MenuItem = styled(Link)`
  height: 64px;
  text-decoration: none;
  flex: 0 1;
`;

const MenuItemTitle = styled.div`
  text-transform: uppercase;
  flex-grow: 1;
  align-items: center;
  display: flex;
  padding-left: 18px;
  color: #3c4b61;
  font-size: 12px;
`;

const MenuItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
`;

const Menu = styled.div`
  background-color: white;
  height: calc(100vh - 80px);
  width: 250px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eeeeee;
`;

const MenuFiller = styled.div`
  flex: 1 1 auto;
`;

const MenuFilter = styled.div`
  border-top: 1px solid #eeeeee;
`;

const MenuItems = styled.div`
  flex: 1 1;
  overflow-y: auto;
`;

const SideMenu: React.FunctionComponent<Props> = (props) => {
  const items = props.menuItems.map((menuItem) => (
    <MenuItem to={menuItem.path} key={menuItem.key || menuItem.title}>
      <MenuItemContainer>
        <MenuItemActive active={props.location.pathname.startsWith(menuItem.path)} />
        <MenuItemTitle>{menuItem.title}</MenuItemTitle>
      </MenuItemContainer>
    </MenuItem>
  ));
  items.push(<MenuFiller key="filler" />);
  let filter;
  if (props.filter) {
    filter = <MenuFilter>{props.filter}</MenuFilter>;
  }

  return (
    <nav style={{ overflowY: 'auto' }}>
      <Menu>
        <MenuItems>{items}</MenuItems>
        {filter}
      </Menu>
    </nav>
  );
};

export default withRouter(SideMenu);
